<template>
  <li class="nav-item" :class="{ active: isActive }">
    <button :data-target="targetName" data-toggle="tab" role="tab" :id="idName" class="nav-link btn btn-default btn-round btn-200" @click.prevent="switchTab">{{ sectionName }}</button>
  </li>
</template>

<script>
  export default {
    name: 'NavTab',
    props: ['sectionName', 'sectionKey', 'activeSection'],
    computed: {
      isActive() {
        return this.activeSection === this.sectionKey;
      },
      targetName() {
        return `#target_${this.sectionKey}`;
      },
      idName() {
        return `switch_${this.sectionKey}`;
      },
    },
    methods: {
      switchTab() {
        // this.$store.dispatch('main/setProperty', { key: 'globalLoading', value: true });
        // this.$router.push(`/allergy-kpis/${this.sectionKey}`);
        this.$store.dispatch('allergyKpis/setProperty', { key: 'activeSection', value: this.sectionKey });
      },
    },
  };
</script>
